<template>
  <div>
    <b-tabs
      v-if="!isHonorario"
      end
    >
      <div
        v-for="(servicosPorDep) in valueInner"
        ref="servicos"
        :key="servicosPorDep.departamento.id"
      >
        <b-tab
          v-if="servicosPorDep.servicos.length > 0"
          :title="servicosPorDep.departamento.nome"
        >
          <tabela-servicos
            :ref="`servicospordepartamento${servicosPorDep.departamento.id}`"
            :value="servicosPorDep.servicos"
            :colunas="colunasServico"
            :mostrar-selecionados="mostrarSelecionados"
            @servico-selecionado="servicoSelecionado($event)"
            @todos-selecionado="todosSelecionado($event)"
          />
        </b-tab>
      </div>
      <slot name="valor-total" />
    </b-tabs>
    <div
      v-else
    >
      <tabela-servicos
        ref="servicoshonorarios"
        :value="servicohonorariochecklist()"
        :colunas="colunasServico"
        :mostrar-selecionados="mostrarSelecionados"
        @servico-selecionado="servicoSelecionado($event)"
        @todos-selecionado="todosSelecionado($event)"
      />
      <slot name="valor-total" />
    </div>
  </div>
</template>

<style lang="scss">
.valor-total {
  float: right;
  width: 23.2rem;
  font-size: 16px;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
export default {
  name: 'ServicoDepartamento',
  components: {
    TabelaServicos: () => import('@/app-modulo/comercial/pacote-servico/shared/components/tabela-servicos/TabelaServicos.vue'),
  },
  props: {
    value: {
      type: [Object, Array],
      default: () => { },
    },
    aplicarFiltro: {
      type: Boolean,
      default: false,
    },
    mostrarSelecionados: {
      type: Boolean,
      default: false,
    },
    valorTotal: {
      type: Number,
      default: 0,
    },
    isHonorario: {
      type: Boolean,
      default: false,
    },
    servicosComHonorario: {
      type: [Object, Array],
      default: () => { },
    },
  },
  data() {
    return {
      colunasServico: [
        { label: 'Nome', field: 'nome', sortable: false },
        {
          label: 'Valor (Auditar)',
          field: 'valorAuditar',
          sortable: false,
          width: '200px',
          type: 'decimal',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
      ],
      value_: null,
      filtrar: false,
      valor_: 0,
      valorRCC_: 0,
      servicosSelecionadosIndividual: [],
    }
  },
  computed: {
    valueInner: {
      get() {
        return this.value_
      },
      set(value) {
        this.value_ = value
      },
    },
    valor: {
      get() {
        return this.valor_
      },
      set(value) {
        this.valor_ = value
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.valueInner = value
      }
    },
    aplicarFiltro(value, oldValue) {
      if (value && value !== oldValue) {
        this.filtrar = value
      }
    },
    valorTotal(value, oldValue) {
      if (value && value !== oldValue) {
        this.valor = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.valor = this.valorTotal
  },
  methods: {
    servicoSelecionado(selecionado) {
      if (selecionado.vgtSelected) {
        this.valor += selecionado.valorAuditar
        this.valorRCC_ += selecionado.valorRCC
        if (!this.isHonorario) {
          this.servicosSelecionadosIndividual.push(selecionado.servicoId)
        }
      } else {
        this.valor -= selecionado.valorAuditar
        this.valorRCC_ -= selecionado.valorRCC
        const indexServico = this.servicosSelecionadosIndividual.indexOf(selecionado.servicoId)
        if (!this.isHonorario && indexServico !== -1) {
          this.servicosSelecionadosIndividual.splice(indexServico, 1)
        }
      }

      this.$emit('valor-total', { valor: this.valor, valorRCC: this.valorRCC_ })
      this.$emit('selecionado-servico', selecionado)
    },
    todosSelecionado(selecionados) {
      if (selecionados.length > 0) {
        this.valor = this.isHonorario ? 0 : this.valor
        selecionados.forEach(sel => {
          if (sel.vgtSelected && !this.servicosSelecionadosIndividual.includes(sel.servicoId)) {
            this.valor += sel.valorAuditar
            this.valorRCC_ += sel.valorRCC
            if (!this.isHonorario) {
              this.servicosSelecionadosIndividual.push(sel.servicoId)
            }
          }
        })
      } else if (this.isHonorario) {
        this.valor = 0
      } else {
        this.valueInner.forEach(fo => fo.servicos.forEach(this.diminuirValor))
      }

      this.$emit('valor-total', { valor: this.valor, valorRCC: this.valorRCC_ })
    },
    diminuirValor(servico) {
      if (servico.selecionadoAntes && !servico.vgtSelected) {
        this.valor -= servico.valorAuditar
        this.valorRCC_ -= servico.valorRCC
        const indexServico = this.servicosSelecionadosIndividual.indexOf(servico.servicoId)
        if (!this.isHonorario && indexServico !== -1) {
          this.servicosSelecionadosIndividual.splice(indexServico, 1)
        }
        this.$set(servico, 'selecionadoAntes', false)
      }
    },
    servicohonorariochecklist() {
      const lista = []
      this.servicosComHonorario.forEach(element => {
        if (element.substituirItens) {
          lista.push(element)
        }
      })
      return lista
    },
  },
}
</script>
